import React from 'react';

function Heading({ headerText, children }) {
  return (
    <div className='margin_bottom_20 d-flex justify-content-between last_question_read'>
      <h1 className='section_head'>{headerText}</h1>
      {children}
    </div>
  );
}

export default Heading;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3EssayQuestions/Layout/Heading.jsx